// extracted by mini-css-extract-plugin
export var content = "electronic-invoicing-module--content--ceae4";
export var wrapper = "electronic-invoicing-module--wrapper--675fe container-module--wrapper--c1517 secondary-footer-module--gray--0a052 secondary-footer-module--wrapper--ce03e container-module--wrapper--c1517";